/**
 * httpInterceptor global config.
 * Register httpInterceptor in $httpProvider interceptors.
 * @param {$httpProvider} $httpProvider - Angular $httpProvider service
 * @constructor
 * @ngInject
 */
export default function InterceptorsConfig($httpProvider) {
    $httpProvider.interceptors.push('httpInterceptor');
}



// WEBPACK FOOTER //
// ./app/services/interceptors/interceptors.config.js